/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your details to estimate your daily calories.`)
};

const es_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tus datos para estimar tus calorías diarias.`)
};

const de_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre Daten ein, um Ihren täglichen Kalorienbedarf zu schätzen.`)
};

const nl_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer uw gegevens in om uw dagelijkse calorieën in te schatten.`)
};

const fr_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez vos données pour estimer vos calories quotidiennes.`)
};

const it_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci i tuoi dati per stimare le tue calorie giornaliere.`)
};

const pt_br2_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite seus dados para estimar suas calorias diárias.`)
};

const pt_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite os seus detalhes para estimar as suas calorias diárias.`)
};

const ja_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細を入力して、日次カロリーを見積もります。`)
};

const zh_bmr_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的信息以估算每日所需卡路里。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_enter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_enter(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_enter", locale)
	if (locale === "en") return en_bmr_enter(inputs)
	if (locale === "es") return es_bmr_enter(inputs)
	if (locale === "de") return de_bmr_enter(inputs)
	if (locale === "nl") return nl_bmr_enter(inputs)
	if (locale === "fr") return fr_bmr_enter(inputs)
	if (locale === "it") return it_bmr_enter(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_enter(inputs)
	if (locale === "pt") return pt_bmr_enter(inputs)
	if (locale === "ja") return ja_bmr_enter(inputs)
	return zh_bmr_enter(inputs)
};